<template>
  <transition name="van-slide-right" appear>
    <div v-show="visible" :class="_.view" @click="$emit('click')">
      <slot />
    </div>
  </transition>
</template>

<script>
  import Vue from 'vue'
  import { pageBridge } from './page_bridge'
  import { throttle } from 'vtils'

  export default Vue.extend({
    data: () => ({
      visible: false,
    }),

    mounted() {
      this.bind()
    },

    activated() {
      this.bind()
    },

    deactivated() {
      this.visible = false
      this._notFirst = false
      this.unbind()
    },

    beforeDestroy() {
      this.unbind()
    },

    methods: {
      bind() {
        const callback = throttle(
          () => {
            clearTimeout(this._timer)
            this.visible = !this._notFirst
            this._notFirst = true
            this._timer = setTimeout(() => {
              this.visible = true
            }, 1000)
          },
          60,
          { trailing: false },
        )
        this._unbind = pageBridge.on('scroll', callback)
        callback()
      },
      unbind() {
        this._unbind?.()
      },
    },
  })
</script>
